import { createContext, useCallback, useContext, useRef } from 'react'

interface TimerFlushContextData {
  registerTimer: (flush: () => void) => () => void
  flushAllTimers: () => void
}

const TimerFlushContext = createContext<TimerFlushContextData>({
  registerTimer: () => () => {},
  flushAllTimers: () => {},
})

export const TimerFlushProvider = ({ children }: { children: React.ReactNode }) => {
  const callbacksRef = useRef<Set<() => void>>(new Set())

  const registerTimer = useCallback((flush: () => void) => {
    callbacksRef.current.add(flush)
    return () => callbacksRef.current.delete(flush)
  }, [])

  const flushAllTimers = useCallback(() => {
    callbacksRef.current.forEach(f => f())
  }, [])

  return (
    <TimerFlushContext.Provider value={{ registerTimer, flushAllTimers }}>
      {children}
    </TimerFlushContext.Provider>
  )
}

export const useTimerFlush = () => useContext(TimerFlushContext)
